import { Modal, TableCustom } from "../../common"
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToIdentificador } from "../../../utils/convert"
import { ServerRequest } from "../../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import { useEffect, useState } from "react"
import { useManagedContext } from "../../hooks"
import ReciboPublicacionModal from "../ReciboPublicacionModal"
const handleCopyNumeroLote = (value) => {
    if (value) {
        navigator.clipboard.writeText(String(value))
        ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'Copiado al portapapeles')
    }
}

const RecaudacionesGridModal = ({ lote, recaudadoraNombre, onCancel }) => {

    const { setIsLoading, showMessageModal } = useManagedContext()

    const [recaudaciones, setRecaudaciones] = useState([])
    const [pagoRendicionLotes, setPagoRendicionLotes] = useState([])
    const [registroContableLotes, setRegistroContableLotes] = useState([])
    const [idReciboPublicacion, setIdReciboPublicacion] = useState(null)


    useEffect(() => {
        if (lote.id > 0) {
            SearchRecaudaciones(lote.id)
        }
    }, [])

    const fetchLote = (url, id) => new Promise((resolve, reject) => {
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            url,
            `/${id}`,
            null,
            res => res.json().then(resolve),
            res => reject(res),
            err => reject(err),
        )
    })

    const SearchLotes = (data) => {
        const idsPagoRendicion = [...new Set(data.map(r => r.idPagoRendicionLote).filter(Boolean))]
        const idsRegistroContable = [...new Set(data.map(r => r.idRegistroContableLote).filter(Boolean))]

        if (idsPagoRendicion.length === 0 && idsRegistroContable.length === 0) {
            setIsLoading(false)
            return
        }

        Promise.all([
            Promise.all(idsPagoRendicion.map(id => fetchLote(APIS.URLS.PAGO_RENDICION_LOTE, id))),
            Promise.all(idsRegistroContable.map(id => fetchLote(APIS.URLS.REGISTRO_CONTABLE_LOTE, id))),
        ])
            .then(([resultPago, resultRegistro]) => {
                setPagoRendicionLotes(resultPago)
                setRegistroContableLotes(resultRegistro)
                setIsLoading(false)
            })
            .catch(err => {
                onRequestError(err)
                setIsLoading(false)
            })
    }

    const SearchRecaudaciones = (idRecaudacionLote) => {
        setIsLoading(true)

        const paramsUrl = `/detalle/${idRecaudacionLote}`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.RECAUDACION_LOTE,
            paramsUrl,
            null,
            res => res.json().then(data => {
                setRecaudaciones(data)
                SearchLotes(data)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onView: (item) => {
            if (item.idReciboPublicacion) {
                setIdReciboPublicacion(item.idReciboPublicacion)
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'No existe un VEP de publicación asociado.');
            }
        },
    }

    return (
        <Modal
            onEscape={onCancel}
            allowFullscreen={true}
            size="xl"
            title={`Recaudaciones — ${recaudadoraNombre} (${getDateToString(lote.fechaLote)})`}
            body={(
                <>
                    <div className="row mb-3">
                        <div className="mb-3 col-12 col-lg-3">
                            <label className="form-label">N° lote</label>
                            <div className="wrapper">
                                <input
                                    type="text"
                                    className="form-control text-truncate"
                                    style={{ paddingRight: lote.numeroLote ? '28px' : undefined }}
                                    value={lote.numeroLote || '-'}
                                    disabled={true}
                                    title={lote.numeroLote ? String(lote.numeroLote) : ''}
                                />
                                {lote.numeroLote && (
                                    <span
                                        className="material-symbols-outlined icon-cruz"
                                        style={{ right: '2px', fontSize: '18px' }}
                                        onClick={() => handleCopyNumeroLote(lote.numeroLote)}
                                        title="Copiar"
                                    >content_copy</span>
                                )}
                            </div>
                        </div>
                        <div className="mb-3 col-12 col-lg-3">
                            <label className="form-label">Importe total</label>
                            <input type="text" className="form-control" value={getFormatNumber(lote.importeTotal, 2)} disabled={true} />
                        </div>
                        <div className="mb-3 col-12 col-lg-3">
                            <label className="form-label">Importe neto</label>
                            <input type="text" className="form-control" value={getFormatNumber(lote.importeNeto, 2)} disabled={true} />
                        </div>
                        <div className="mb-3 col-12 col-lg-3">
                            <label className="form-label">Archivo</label>
                            <input type="text" className="form-control text-truncate" value={lote.nombreArchivoRecaudacion || '-'} disabled={true} title={lote.nombreArchivoRecaudacion || ''} />
                        </div>
                    </div>

                    {pagoRendicionLotes.length > 0 && (
                        <TableCustom
                            className={'TableCustomBase m-top-10'}
                            data={pagoRendicionLotes}
                            columns={[
                                { Header: 'N° lote Rend. IIPP', accessor: 'numeroLote', width: '50%' },
                                { Header: 'Casos', accessor: 'id', width: '50%', Cell: ({ value }) => recaudaciones.filter(r => r.idPagoRendicionLote === value).length },
                            ]}
                            showFilterGlobal={false}
                            showDownloadCSV={false}
                        />
                    )}

                    {registroContableLotes.length > 0 && (
                        <TableCustom
                            className={'TableCustomBase m-top-10'}
                            data={registroContableLotes}
                            columns={[
                                { Header: 'N° lote Rend. Contaduría', accessor: 'numeroLote', width: '50%' },
                                { Header: 'Casos', accessor: 'id', width: '50%', Cell: ({ value }) => recaudaciones.filter(r => r.idRegistroContableLote === value).length },
                            ]}
                            showFilterGlobal={false}
                            showDownloadCSV={false}
                        />
                    )}

                    <TableCustom
                        className={'TableCustomBase m-top-10'}
                        data={recaudaciones}
                        avmr={avmr}
                        columns={[
                            { Header: 'N° control', accessor: 'numeroControl', width: '10%' },
                            { Header: 'N° cuenta', accessor: 'numeroCuenta', width: '20%' },
                            {
                                Header: 'Identificador VEP',
                                accessor: 'numeroRecibo',
                                width: '25%',
                                Cell: ({ row }) =>
                                    row.original.numeroRecibo > 0
                                        ? getNumeroRecibo_ObjectToIdentificador(row.original)
                                        : row.original.codigoBarras
                            },
                            { Header: 'Fecha de conciliación', accessor: 'fechaConciliacion', Cell: data => getDateToString(data.value), width: '15%' },
                            { Header: 'Fecha de cobro', accessor: 'fechaCobro', Cell: data => getDateToString(data.value), width: '15%' },
                            { Header: 'Importe', accessor: 'importeCobro', Cell: data => getFormatNumber(data.value, 2), width: '15%', alignCell: 'right' },
                        ]}
                        showDownloadCSV={true}
                    />

                    {idReciboPublicacion && (
                        <ReciboPublicacionModal
                            id={idReciboPublicacion}
                            onCancel={() => setIdReciboPublicacion(null)}
                        />
                    )}
                </>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                </div>
            )}
        />
    )
}

export default RecaudacionesGridModal